<template>
  <div class="big-calendar">
    <el-switch
      v-if="false"
      :width="60"
      style="display: block"
      v-model="switchMode"
      active-color="#67C23A"
      inactive-color="#0288D1"
      active-text="Сессии"
      inactive-text="События"
    />
    <div class="calendars-wrp" v-if="!switchMode">
      <el-select
        v-model="valueSelectDate"
        placeholder="Select"
        @change="changeVisibleFormat"
      >
        <el-option
          v-for="item in utilityData.selectDate"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <div class="calendars-container">
        <sweet-calendar
          ref="sweetCalendar"
          v-for="(calendar, index) of valueSelectDate"
          :key="index"
          class="sweetCalendar"
          :arrow="dateCollection.length > 1"
          :initialDate="dateCollection[index]"
          :eventCategories="eventCategories"
          :events="events"
          :firstDayOfWeek="2"
          :offDays="[1, 7]"
          @prevMonth="changeMonth"
          @nextMonth="changeMonth"
        />

        <el-button class="calendar__sync" @click="showSyncModal">
          <i class="el-icon-date"></i> Синхронизировать календарь
        </el-button>
      </div>
      <div :class="['event-galary', { galaryShow: selectEvent.length }]">
        <div v-if="mobileMode" class="event-galary__go-back-btn">
          <button @click="closeGalary()">
            <i class="el-icon-circle-close"></i>
          </button>
        </div>
        <template v-if="selectEvent.length">
          <div
            class="event-galary__item"
            v-for="event of selectEvent"
            :key="event.sid"
          >
            <h4 class="event-description__title">{{ event.discipline }}</h4>
            <p class="event-description__param">
              Дата: <span>{{ event.currentdate }}</span>
            </p>
            <p class="event-description__param">
              Аудитория: <span>{{ event.room }}</span>
            </p>
            <p class="event-description__param">
              Дисциплина: <span>{{ event.discipline }}</span>
            </p>
            <p class="event-description__param">
              Тип: <span>{{ event.type_workload }}</span>
            </p>
            <p class="event-description__param">
              Начало: <span>{{ event.time_begin }}</span>
            </p>
            <p class="event-description__param">
              Продолжительность: <span>{{ event.duration }} мин</span>
            </p>
            <a
              v-for="(link, name, idx) in event.hrefList"
              class="event-description__link"
              :href="link"
              :key="idx"
            >
              <span>
                {{
                  name === "webinar"
                    ? "Перейти к вебинару"
                    : "Скачать презентацию"
                }}
              </span>
              <i class="el-icon-caret-right"></i>
            </a>
            <router-link
              class="event-description__link"
              :to="{ path: '/journal-new', query: {
                discipline_id: event.discipline_id,
                date: event.date,
                groupId: event.groups?.[0]?.group_id || null
              }}"
              >Перейти в журнал посещений <i class="el-icon-caret-right"></i
            ></router-link>
            <div class="event-description__tags">
              <el-tag
                v-for="group in event.groups"
                effect="dark"
                :key="`tag-group-${group.group_id}`"
              >
                {{ group.group }}
              </el-tag>
            </div>
          </div>
        </template>
        <h4 v-else class="event-galary__not-select-message">
          Выберите событие
        </h4>
      </div>
    </div>
    <session-table v-if="switchMode" />
  </div>
</template>
<script>
import sessionsTable from "../components/journal/sessionsTable";
import { mapMutations, mapActions } from "vuex";
import sweetCalendar from "../components/sweetCalendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";
import filter from "../components/journal/filter.vue";
export default {
  name: "Journal",
  components: {
    "sweet-calendar": sweetCalendar,
    "filter-event": filter,
    "session-table": sessionsTable,
  },
  data() {
    return {
      switchMode: false,
      utilityData: {
        selectDate: [
          {
            label: "Месяц",
            value: 1,
          },
          {
            label: "Три месяца",
            value: 3,
          },
          {
            label: "Год",
            value: 12,
          },
        ],
      },
      dateCollection: [],
      date: new Date(),
      valueSelectDate: 1,
      eventCategories: [
        {
          id: 1,
          title: "Personal",
          textColor: "white",
          backgroundColor: "#0288D1",
        },
        {
          id: 2,
          title: "Company-wide",
          textColor: "white",
          backgroundColor: "#f56c6c",
        },
      ],
      events: [],
    };
  },

  computed: {
    currentdate() {
      return this.valueSelectDate;
    },
    selectEvent() {
      return this.$store.state.journal.selectEvent;
    },
    curentRoute() {
      return this.$route.path;
    },
    dataPage() {
      return this.$store.state.dataPage.schedule;
    },
    mobileMode() {
      return this.$store.state.mobileMode;
    },
  },
  methods: {
    ...mapActions(["fetchDataForPage"]),

    ...mapMutations({
      setSelectDate: "journal/SET_SELECT_DATE",
      setSelectEvent: "journal/SET_SELECT_EVENT",
      setModalData: "setModalData",
    }),

    showSyncModal() {
      this.setModalData({ name: "syncCalendarModal" });
    },

    changeMonth(v) {
      this.getEvents(v._date).then((data) => {
        this.events = data;
        this.setEventsAtributes();
      });
    },

    changeVisibleFormat(value) {
      let date = new Date();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      let dateArray = [];
      let m = Number(month);
      let y = Number(year);
      for (let i = 1; i <= Math.floor(value / 2); i++) {
        if (m === 1) {
          m = 12;
          y--;
          dateArray.push(y + "-" + m);
        } else {
          --m;
          dateArray.push(y + "-" + m);
        }
      }

      y = Number(year);
      m = Number(month);
      dateArray.reverse();
      for (let i = 1; i <= Math.ceil(value / 2); i++) {
        if (m > 12) {
          m = 1;
          y = y + 1;
        }

        dateArray.push(y + "-" + m);
        m = m + 1;
      }
      this.dateCollection = dateArray;
      this.events = [];
      this.dateCollection.forEach((el) => {
        this.getEvents(new Date(el)).then((data) => {
          data.forEach((element) => {
            element.categoryId = 1;
            element.currentdate = this.dataEditor(element.date);
            this.events.push(element);
          });
        });
      });
    },

    goToday() {
      this.$refs.sweetCalendar.goToday();
    },

    closeGalary() {
      this.$store.commit("journal/SET_SELECT_EVENT", null);
    },

    goSelectDate() {
      this.$refs.sweetCalendar.goSelectDate();
    },

    dataEditor(value) {
      return value.split("-").reverse().join(".");
    },
    async getEvents(date) {
      let shedule = "";
      let obj = { date_filter: date };
      await this.axios.get("/api/journal", { params: obj }).then((res) => {
        shedule = res.data.schedule;
      });
      return shedule;
    },

    setEventsAtributes() {
      this.events.forEach((el) => {
        el.categoryId = 1;
        el.currentdate = this.dataEditor(el.date);
      });
    },
  },
  beforeMount() {
    this.dateCollection.push(
      this.date.getFullYear() + "-" + (Number(this.date.getMonth()) + 1)
    );
  },
  mounted() {
    this.getEvents(new Date()).then((data) => {
      this.events = data;
      this.setEventsAtributes();
    });
    this.$store.state.journal.selectDate ? this.goSelectDate() : null;
  },
  beforeDestroy() {
    this.setSelectDate(null);
    this.setSelectEvent(false);
  },
};
</script>
<style lang="scss">
.big-calendar {
  justify-items: center;
  height: 100%;
  display: grid;
  align-items: center;
  row-gap: 10px;
  grid-template-rows: max-content 1fr;
  overflow: hidden;
  .sweetCalendar {
    width: 100%;
    background-color: $basic-white;
  }
  .el-switch__label * {
    font-size: 18px;
  }
  .select-visible-format {
    justify-self: center;
    max-width: 300px;
    width: 100%;
  }
  .row1-3 {
    width: 100%;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 20px;
  }
  .row3-3 {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 20px;
    row-gap: 20px;
    height: max-content;
  }
  .calendars-wrp {
    align-self: flex-start;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-template-rows: max-content 1fr;
    column-gap: 10px;
    overflow: hidden;
  }
  .calendars-container {
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    max-height: calc(100dvh - 100px);

    @include breakPoints(md) {
      max-height: calc(100dvh - 170px);
    }
  }
  .sweetCalendar {
    margin: 0 auto;
    max-width: 400px;
  }
  .event-galary {
    grid-column-start: 2;
    grid-column-end: 2;
    grid-row-start: 1;
    grid-row-end: 3;
    height: 100%;
    width: 100%;
    border-left: 1px solid #c0c4cc;
    background-color: #fff;
    margin: 0;
    overflow-y: auto;
    max-height: calc(100dvh - 40px);
  }

  .calendar__sync {
    margin: 0 auto;
  }

  .event-galary__go-back-btn {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    button {
      padding: 0;
      background-color: $basic-white;
      color: $brand-clr-1;
      font-size: 20px;
      line-height: 0;
    }
  }
  .event-galary__item {
    display: grid;
    row-gap: 10px;
    padding: 10px;
    width: 100%;
    border-bottom: 1px solid $base-border-clr;
  }
  .event-galary__not-select-message {
    text-align: center;
    font-weight: normal;
  }
  .event-description__title {
    text-align: center;
  }
  .event-description__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .event-description__link,
  .event-description__param {
    width: 100%;
    display: block;
    margin: 0;
    span {
      color: $brand-clr-1;
    }
  }
  .event-description__link {
    max-width: 275px;
    display: grid;
    grid-template-columns: 1fr 20px;
    column-gap: 10px;
    justify-items: center;
    align-items: center;
    word-wrap: break-all;
    transition-duration: 0.3s;
    transition-property: color background-color;
    border: 1px solid $placeholder-text-clr;
    padding: 10px;
    border-radius: 10px;
    color: $brand-clr-1;
    background-color: rgba($color: $brand-clr-1, $alpha: 0.05);
    span {
      color: inherit;
      justify-self: flex-start;
      text-align: left;
    }
    &:hover {
      border-color: $brand-clr-1;
      background-color: rgba($color: $brand-clr-1, $alpha: 1);
      color: $basic-white;
    }
  }
}

@media (max-width: 800px) {
  .big-calendar {
    padding-top: 20px;
    .calendars-wrp {
      grid-template-columns: 1fr;
      row-gap: 10px;
    }
    .event-galary {
      padding-top: 50px;
      transition-duration: 0.3s;
      transition-property: transform;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      transform: translateX(-120%);
      border: none;
      background-color: $basic-white;
      z-index: 12;
    }
    .event-galary__go-back-btn {
      border-radius: 50%;
      display: block;
      overflow: hidden;
      margin-left: auto;
      top: 10px;
      right: 10px;
      position: sticky;
      padding: 0;
      text-align: right;
      i {
        font-size: 32px;
      }
    }
    .event-galary__not-select-message {
      display: none;
    }
    .galaryShow {
      transform: translateX(0);
    }

    .calendars-container {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
